// extracted by mini-css-extract-plugin
module.exports = {"container":"Text_container__3eadx","toolbar":"Text_toolbar__r0_jH","toolbarButton":"Text_toolbarButton__1AZi2","editor":"Text_editor__1UkMD","flex1":"Text_flex1__2HRvk"};